import qs from 'qs'

export default {
    namespaced: true,
    state: {
        open: false,
        show_loader: false,
        products: {},
        total_cost: 0,
        total_coupon: 0,
        shipment_cost: 0,
        cart_count: 0,
        cart_currency: "PLN",
        checkout_link: false,
        my_account_link: false,
        giftPopupIsOpen: false,
        giftPopupData: {}
    },
    mutations: {
        open(state) {
            state.open = true;
        },
        close(state) {
            state.open = false;
        },
        toggle(state) {
            state.open = !state.open
        },
        products(state, items) {
            state.products = items
        },
        total_cost(state, price) {
            state.total_cost = price
        },
        set_total_coupon(state, price) {
            state.total_coupon = price
        },
        cart_count(state, count) {
            state.cart_count = count
        },
        set_currency(state, currency) {
            state.cart_currency = currency
        },
        set_loader(state, status) {
            state.show_loader = status
        },
        set_checkout_link(state, link) {
            state.checkout_link = link
        },
        set_my_account_link(state, link) {
            state.my_account_link = link
        },
        set_shipment_cost(state, shipment_price) {
            state.shipment_cost = shipment_price
        },
        giftPopupVisibility(state, status) {
            state.giftPopupIsOpen = status
        },
        setGiftPopupData(state, data) {
            state.giftPopupData = data
        }
    },
    actions: {
        async getCartItems({commit, state}) {
            commit('set_loader', true);
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'get_cart_content',
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            }).then((res) => {
                // await this.axios.get(window.global.ajax, {params: {action: 'get_cart_content'}}).then((res) => {
                if (res.data.success) {
                    commit('products', res.data.data.cart_product);
                    commit('total_cost', res.data.data.total_cost)
                    commit('set_total_coupon', res.data.data.total_coupon)
                    commit('cart_count', res.data.data.cart_count)
                    commit('set_currency', res.data.data.currency)
                    commit('set_checkout_link', res.data.data.checkout_link)
                    commit('set_my_account_link', res.data.data.my_account_link)
                    commit('set_shipment_cost', res.data.data.shipment_price)
                    commit('set_loader', false);
                }
            }).catch((e) => {
            })
        },
        async getGift({commit, state}) {
            commit('set_loader', true);
            let params = {
                action: 'checkMyGifts',
                // security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(params))
                .then((res) => {
                    if (res.data.success) {
                        commit('setGiftPopupData', {
                            "gift_product": res.data.data.promo,
                            "popup_title": res.data.data.title
                        })
                    }
                }).catch((e) => {
                })
        },
        async setGiftProduct({commit, state}) {
            commit('set_loader', true);
            let params = {
                action: 'addGiftToCart',
                productPromoId: state.giftPopupData["gift_product"]["id"],
            }
            await this.axios.post(window.global.ajax, qs.stringify(params))
                .then((res) => {
                    if (res.data.success) {
                        this.commit('alerts/set_alert', {'message': res.data.data, 'success': res.data.success})
                    } else {
                        this.commit('alerts/set_alert', {'message': res.data.data, 'success': res.data.success})
                    }
                    commit('set_loader', false);
                }).catch((e) => {
                    console.log('error')
                })
        },
        async removeProductFromCart({commit, state}, comp_data) {
            let parameters = {
                action: 'remove_product_from_cart',
                data: comp_data,
                security: window.global.ajax_nonce,
            }
            commit('set_loader', true);
            let data = await this.axios.post(window.global.ajax, qs.stringify(parameters)).then(() => {
                commit('set_loader', false);
            });
        },
        async change_quantity({commit, state, dispatch}, comp_data) {
            let params = {
                action: 'cart_change_quantity_items',
                data: comp_data,
                security: window.global.ajax_nonce,

            }
            commit('set_loader', true);
            let data = await this.axios.post(window.global.ajax, qs.stringify(params)).then(async (res) => {
                await dispatch('getCartItems');
                if (!res.data.success) {
                    this.commit('alerts/set_alert', {'message': res.data.data.message, 'success': res.data.success})
                }
                commit('set_loader', false);
            });
        }
    },
    getters: {
        is_open: (state) => state.open,
        get_items: (state) => state.products,
        get_total_cost: (state) => state.total_cost,
        get_total_coupon: (state) => state.total_coupon,
        get_cart_count: (state) => state.cart_count,
        get_shipment_cost: (state) => state.shipment_cost,
        get_cart_currency: (state) => state.cart_currency,
        show_loader: (state) => state.show_loader,
        get_checkout_link: (state) => state.checkout_link,
        get_my_account_link: (state) => state.my_account_link,
        getGiftPopupVisibility: (state) => state.giftPopupIsOpen,
        getGiftPopupData: (state) => state.giftPopupData
    }
};